import { memo, useContext } from "react";
import { ApplicationFlowStateContext } from "src/apps/AppFlow/screens/root";
import { useIdentityVerificationQuestionsWithContext } from "src/apps/AppFlow/screens/root/Layout/sections/IdentityVerification/query";

import IdVerificationDecisionLayout, { IdVerificationDecisionLayoutProps } from "./Layout";

export interface IdVerificationDecisionProps
  extends Omit<IdVerificationDecisionLayoutProps, "onChange" | "onNext"> {
  onNext: () => void;
}

const IdVerificationDecision = ({ onNext, ...props }: IdVerificationDecisionProps) => {
  const { state, dispatch } = useContext(ApplicationFlowStateContext);

  const { loading } = useIdentityVerificationQuestionsWithContext({ state, dispatch });

  return <IdVerificationDecisionLayout {...props} nextLoading={loading} onNext={onNext} />;
};

export default memo(IdVerificationDecision);
